import { useState, useEffect, useRef } from "react";
import { 
  subscribeToAcquisitions, 
  seedAcquisitionsIfEmpty,
  addAcquisition,
  updateAcquisition,
  deleteAcquisition
} from "../services/acquisitionsService";
import { useVendors } from "./useVendors";

export function useAcquisitions() {
  const [acqs, setAcqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const { vendors } = useVendors();
  const hasSeededRef = useRef(false);

  useEffect(() => {
    let unsubscribe = () => {};

    try {
      setLoading(true);
      unsubscribe = subscribeToAcquisitions(async (data, err) => {
        if (err) {
          setError("Failed to load acquisitions.");
          setLoading(false);
          return;
        }

        if (data.length === 0 && vendors.length > 0 && !hasSeededRef.current) {
          hasSeededRef.current = true;
          await seedAcquisitionsIfEmpty(data, vendors);
        } else {
          setAcqs(data);
          setLoading(false);
        }
      });
    } catch (err) {
      console.error(err);
      setError("Failed to initialize acquisitions subscription.");
      setLoading(false);
    }

    return () => unsubscribe();
  }, [vendors]);

  const handleAddAcquisition = async (acqData) => {
    try {
      setError("");
      return await addAcquisition(acqData);
    } catch (err) {
      console.error("Error adding acquisition:", err);
      setError(err.message || "Failed to add acquisition.");
      throw err;
    }
  };

  const handleUpdateAcquisition = async (id, acqData) => {
    try {
      setError("");
      await updateAcquisition(id, acqData);
    } catch (err) {
      console.error("Error updating acquisition:", err);
      setError(err.message || "Failed to update acquisition.");
      throw err;
    }
  };

  const handleDeleteAcquisition = async (id) => {
    try {
      setError("");
      await deleteAcquisition(id);
    } catch (err) {
      console.error("Error deleting acquisition:", err);
      setError(err.message || "Failed to delete acquisition.");
      throw err;
    }
  };

  return {
    acqs,
    loading,
    error,
    setError,
    addAcquisition: handleAddAcquisition,
    updateAcquisition: handleUpdateAcquisition,
    deleteAcquisition: handleDeleteAcquisition
  };
}
